<div class="content-view">
  <div class="row">
    <div class="col-md-8">
      <mat-card>Simple card</mat-card>
    </div>
    <div class="col-md-4">
      <mat-card>Simple card</mat-card>
    </div>
  </div>
</div>